import React from "react";
import $ from "jquery";

import Table from "../../common/Table";
import { formatDateString } from "../../utils/format";

class RequestQuoteChangeTable extends React.Component {
  componentDidMount() {
    $(this.refs.table.refs.main).on("click", "input[type=checkbox]", (e) => {
      $("input[type=checkbox]").each((_, checkbox) => {
        if (this.props.selected.includes(checkbox.value)) {
          checkbox.checked = false;
        }
      });

      if (this.props.selected.includes(e.target.value)) {
        this.props.unselectRequest(e.target.value);
      } else {
        this.props.selectRequest(e.target.value);
      }
    });
  }

  render() {
    const isAnySelected = this.props.selected.length > 0;

    return (
      <div className="service-request-submit">
        <Table
          className="form-group"
          paging={false}
          ref="table"
          data={this.props.requests}
          columnDefs={[
            {
              data: "Id",
              searchable: false,
              orderable: false,
              title: "Select",
              width: "100px",
              render: function (data, type, full, meta) {
                return (
                  '<input style="margin-left: 10px" type="checkbox" name="id[]" class="anythingControls policyCheckbox" value="' +
                  $("<div/>").text(data).html() +
                  '">'
                );
              },
              targets: [0],
            },
            {
              data: "LineOfBusiness",
              width: "250px",
              autowidth: true,
              title: "Line of Business",
              targets: [1],
              defaultContent: "",
              className: "",
            },
            {
              data: "BillingCarrier",
              width: "200px",
              autowidth: true,
              title: "Carrier",
              targets: [2],
              defaultContent: "",
              className: "",
            },
            {
              data: "PolicyNumber",
              width: "100px",
              autowidth: true,
              title: "Policy #",
              targets: [3],
              defaultContent: "",
              className: "",
            },
            {
              data: "ExpDate",
              width: "auto",
              autowidth: true,
              title: "Expiration Date",
              targets: [4],
              defaultContent: "",
              className: "",
              render: (v) => formatDateString(v),
            },
          ]}
        />
        <button
          disabled={!isAnySelected}
          className="btn btn-primary float-right mt-3 px-4"
          onClick={() => this.props.nextStep()}
        >
          Continue
        </button>
        <button
          className="btn btn-default float-right mr-2 mt-3 px-4"
          onClick={() => this.props.goBack()}
        >
          Cancel
        </button>
      </div>
    );
  }
}

export default RequestQuoteChangeTable;
